import {
  LIST_PAGED_MERGE_PROPS,
  LIST_PAGED_LOADING,
  LIST_PAGED_FAILURE,
  LIST_PAGED_SUCCESS,
  LIST_PAGED_DESTROY,
} from '../actions/resourceListPaged';
import { Record, Map } from 'immutable';

const ResourceListStruct = Record({
  resource: null,
  requestId: null,
  data: null,
  loading: false,
  page: 1,
  totalCount: 0,
  limit: 20,
  order: 'desc',
  orderBy: 'id',
  timestamp: null,
  filter: {},
  filterProps: [],
  message: null,
});

export default function(state = new Map(), action) {
  const { data, message, requestId } = action;
  let newState = state;
  switch (action.type) {
    case LIST_PAGED_MERGE_PROPS:
      if (!state.get(requestId)) {
        newState = state.setIn([requestId], new ResourceListStruct(action));
      }
      Object.keys(action.value).map((key, index) => {
        newState = newState.setIn([requestId, key], action.value[key]);
        return newState;
      });
      return newState;

    case LIST_PAGED_LOADING:
      if (!state.get(requestId)) {
        newState = state.setIn([requestId], new ResourceListStruct(action));
      }
      return newState.setIn([requestId, 'loading'], true);
    case LIST_PAGED_SUCCESS:
      return state
        .setIn([requestId, 'loading'], false)
        .setIn([requestId, 'data'], !!data.data ? data.data : [])
        .setIn(
          [requestId, 'totalCount'],
          !!data.totalCount ? data.totalCount : 0,
        );
    case LIST_PAGED_FAILURE:
      return state
        .setIn([requestId, 'loading'], false)
        .setIn([requestId, 'message'], message)
        .setIn([requestId, 'data'], null);

    case LIST_PAGED_DESTROY:
      return state.delete(requestId);

    default:
      return state;
  }
}
